import axios from "../../../../../../api/axiosInstance";
import { ProductSearchConfig } from "./types";

export const fetchProductSearchConfig =
  async (): Promise<ProductSearchConfig> => {
    const response = await axios.get<ProductSearchConfig>(
      "/api/search/config/products",
    );
    return response.data;
  };
